
import tippy from 'tippy.js';
import urlJoin from 'url-join';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/material.css';
import 'tippy.js/themes/light-border.css';
import 'tippy.js/animations/scale.css';
import { getInfoIconHtml } from '../../../../includes/assets/js/modules/dpitUtilsInc';

export default class AcfTippy {

	constructor(config, onInitialized = null) {
		if (config.dpDebugEn) console.log('[dpit] INIT AcfTippy');
		this.onInitializedCb = onInitialized;
		this.init(config);
	}

	init = (config) => {

		$('#post-body-content .acf-field:not(.acf-field-group):not(.acf-field--no-info-icon) .acf-label').each((idx, element) => {
			const jDescElement = $(element).find('.description');
			const jAcfField = $(element).closest('.acf-field');
			const jMsgElement = jAcfField.find('span.message');
			let descText = jDescElement.html();
			let text = jMsgElement.html() || '';
			if (text && descText) text += '<br>';
			text += jDescElement.html() || '';
			if (text.length) {
				const iconClass = jAcfField.hasClass('acf-field--ia') ? 'dpit-info-icon dpit-info-icon--ia' : 'dpit-info-icon';
				$(element).addClass('acf-label--with-info-icon').append(getInfoIconHtml(iconClass, text, $(element).children('label').text()));
				jDescElement.add(jMsgElement).hide();
			}
		});

		if (config.stepDefinitions) {

			Object.keys(config.stepDefinitions).forEach((key) => {
				const data = config.stepDefinitions[key];
				if (data.hint) {
					$('#acf-t-header-' + key).addClass('acf-table-header-cell--with-info-icon').append(getInfoIconHtml('dpit-info-icon dpit-info-icon--in-table-header', data.hint, data.title.replace(/(<([^>]+)>)/gi, '')));
				}
			});
		}
		//	theme: 
		$('.dpit-info-icon').each((idx, element) => {
			const interactive = $(element).hasClass('dpit-info-icon--ia');
			const theme = $(element).hasClass('dpit-info-icon--modal') ? 'light-border' : 'material';
			tippy(element, {
				content: (reference) => reference.getAttribute('data-info-text'),
				animation: 'scale',
				theme: theme,
				allowHTML: true,
				interactive: interactive,
				zIndex: 100000003
			});
		});

		setTimeout(() => {
			document.getElementById(config.acfRootElId)?.classList.add('dpit-acf-tippy');

			const firstInfoIcon = document.querySelector('.dpit-info-icon');
			if (firstInfoIcon) {
				$(firstInfoIcon).load(
					urlJoin(config.assetsUrl, '../../includes/assets/icons/info-circle-solid.svg'),
					() => this.onInfoIconLoaded(firstInfoIcon)
				);
			}
		}, 300);
	};

	reloadInfoIcons() {
		const firstFilledInfoIconEl = document.querySelector('.dpit-info-icon--loaded');
		if (firstFilledInfoIconEl) {
			const $allNotLoadedIconsEls = $('.dpit-info-icon:not(.dpit-info-icon--loaded)');
			$allNotLoadedIconsEls.html(firstFilledInfoIconEl.innerHTML);
		}
	}

	onInfoIconLoaded = (firstInfoIcon) => {
		const $allIconsEls = $('.dpit-info-icon');
		$allIconsEls.html(firstInfoIcon.innerHTML);
		$allIconsEls.addClass('dpit-info-icon--loaded');
		$allIconsEls.show();
		if (this.onInitializedCb instanceof Function) this.onInitializedCb();
	};
}